import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { css } from 'styled-components';
import { FontVariant as FV } from '../../utils/types/typography';
import { LabelSize } from './types/size';
export var fontSizeLabelMixin = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LabelSize.Sm, function (_ref) {
  var font = _ref.theme.typography.font;
  return css(font[FV.LabelSmall]);
}), LabelSize.Md, function (_ref2) {
  var font = _ref2.theme.typography.font;
  return css(font[FV.LabelMedium]);
}), LabelSize.Lg, function (_ref3) {
  var font = _ref3.theme.typography.font;
  return css(font[FV.LabelLargeEmphasis]);
}), LabelSize.Xl, function (_ref4) {
  var font = _ref4.theme.typography.font;
  return css(font[FV.LabelExtraLargeEmphasis]);
});